export default "__VITE_ASSET__826fffd9__"